import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './hooks/useAuth';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import Listings from './pages/Listings';
import ListingDetail from './pages/ListingDetail';
import SellListing from './pages/SellListing';
import { Login, Signup } from './pages/Auth';
import Messages from './pages/Messages';
import MyListings from './pages/MyListings';
import BikeOfTheWeek from './pages/BikeOfTheWeek';
import Settings from './pages/Settings';
import './index.css';
import Privacy      from './pages/Privacy';
import Terms        from './pages/Terms';
import CookiePolicy from './pages/CookiePolicy';
import Disclaimer   from './pages/Disclaimer';
import Admin from './pages/Admin';

function Footer() {
  return (
    <footer style={{
      borderTop: '1px solid var(--border)',
      padding: '36px 0',
      marginTop: 'auto',
      color: 'var(--text-dim)',
      fontSize: '0.8rem',
    }}>
      <div className="container" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 16, flexWrap: 'wrap' }}>
        <span style={{ fontFamily: 'var(--font-display)', fontSize: '1.1rem', letterSpacing: '0.1em' }}>
          <span style={{ color: 'var(--primary)' }}>ELEC</span>
          <span style={{ color: 'var(--text-dim)' }}>TRADEZ</span>
        </span>
        <span>The Electric Moto Marketplace — &copy; {new Date().getFullYear()}</span>
        <nav style={{ display: 'flex', gap: 16 }}>
          <a href="/privacy"    style={{ color: 'var(--text-dim)', textDecoration: 'none', fontSize: '0.75rem' }}>Privacy</a>
          <a href="/terms"      style={{ color: 'var(--text-dim)', textDecoration: 'none', fontSize: '0.75rem' }}>Terms</a>
          <a href="/cookies"    style={{ color: 'var(--text-dim)', textDecoration: 'none', fontSize: '0.75rem' }}>Cookies</a>
          <a href="/disclaimer" style={{ color: 'var(--text-dim)', textDecoration: 'none', fontSize: '0.75rem' }}>Disclaimer</a>
        </nav>
      </div>
    </footer>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
          <Navbar />
          <main style={{ flex: 1 }}>
            <Routes>
              <Route path="/"              element={<Home />} />
              <Route path="/listings"      element={<Listings />} />
              <Route path="/listings/:id"  element={<ListingDetail />} />
              <Route path="/sell"          element={<SellListing />} />
              <Route path="/sell/edit/:id" element={<SellListing />} />
              <Route path="/login"         element={<Login />} />
              <Route path="/signup"        element={<Signup />} />
              <Route path="/messages"      element={<Messages />} />
              <Route path="/my-listings"   element={<MyListings />} />
              <Route path="/bike-of-the-week" element={<BikeOfTheWeek />} />
              <Route path="/settings"      element={<Settings />} />
              <Route path="/privacy"    element={<Privacy />} />
              <Route path="/terms"      element={<Terms />} />
              <Route path="/cookies"    element={<CookiePolicy />} />
              <Route path="/disclaimer" element={<Disclaimer />} />
              <Route path="/admin" element={<Admin />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </AuthProvider>
    </BrowserRouter>
  );
}
